import { render, staticRenderFns } from "./index.vue?vue&type=template&id=509dcf25&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=509dcf25&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509dcf25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('509dcf25')) {
      api.createRecord('509dcf25', component.options)
    } else {
      api.reload('509dcf25', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=509dcf25&scoped=true", function () {
      api.rerender('509dcf25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pattern/components/custom-table/index.vue"
export default component.exports